module.exports = __webpack_public_path__ + "img/logow.f77ac111.png";